import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PlaygroundGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean {
    const url = window.location.href.toLowerCase();

    // Allow access in dev, qa environments and localhost
    const allowedEnvironments = [
      'localhost',
      'dev-',
      'dev.',
      'qa-',
      'qa.'
    ];

    const isAllowedEnvironment = allowedEnvironments.some(env => url.includes(env));

    if (!isAllowedEnvironment) {
      // Redirect to 404 if not allowed
      this.router.navigate(['/404']);
      return false;
    }

    return true;
  }
}
